<template lang="pug">
v-card
  v-card-title.d-flex.justify-center(style='color:#222222; font-weight: 700; font-size: 20px;') {{$t('ADD_KNOWLEDGE.TITLE')}}
  v-card-text
    v-form(v-model="valid", ref="form")
      // 名稱
      v-row.mt-2
        v-col.pa-0(cols='3').d-flex.justify-start
          div(style='color:#444444; font-weight: 500; font-size: 14px;') {{$t('ADD_KNOWLEDGE.NAME')}}
        v-col.pa-0
          v-text-field(
            v-model='addData.name',
            outlined,
            :placeholder=`$t('ADD_KNOWLEDGE.NAME_PH')`,
            dense
            :rules='formRule.nameRules',
            required='required',
            :hint=`$t('ADD_KNOWLEDGE.NAME_HINT')`
            persistent-hint
          )
      //Parent 路徑
      v-row.mt-2(v-if='!is_private && folder_mode')
        v-col.pa-0(cols='3').d-flex.justify-start
          div(style='color:#444444; font-weight: 500; font-size: 14px;') {{$t('ADD_KNOWLEDGE_FOLDER.PATH')}}
        v-col.pa-0(cols='8')
          v-text-field(
            v-model='addFolderData.path'
            outlined
            dense
            :rules='formRule.pathRules'
            required='required'
            readonly
            @click='openFolderPick'
          )
        v-col.pa-0(cols='1')
          v-btn.pa-0(plain ripple style='width:40px; height:28px;' @click='openFolderPick')
            v-img.mr-1(src="@/assets/images/folder-btn.svg" max-height="30" max-width="30")
      // 類別
      v-row.mb-2
        v-col.pa-0(cols='3').d-flex.justify-start
          div(style='color:#444444; font-weight: 500; font-size: 14px;') {{$t('ADD_KNOWLEDGE.CATEGORY')}}
        v-col.pa-0(cols='9')
          v-combobox.bg-white(
            v-model='addData.category',
            height='30',
            dense,
            outlined,
            clearable,
            :placeholder=`$t('ADD_KNOWLEDGE.CATEGORY_PH')`,
            :items='category_list',
            item-value='id',
            item-text='name',
            :rules='formRule.categoryRules',
            :hint=`$t('ADD_KNOWLEDGE.CATEGORY_HTNT')`
            persistent-hint
          )
      // System name
      v-row(style='margin-top: -10px')
        v-col.pa-0(cols='3').d-flex.justify-start
          div(style='color:#444444; font-weight: 500; font-size: 14px;') {{$t('GPT_KNOWLEDGE.SYSTEM_NAME_LABEL')}}
        v-col.pa-0
          v-text-field.mb-2(
            v-model='addData.system_name',
            outlined,
            placeholder='System Name',
            dense
            :rules='formRule.system_nameRules',
            required='required',
            :hint=`$t('ADD_KNOWLEDGE.SYSTEM_NAME_HINT')`
            persistent-hint
          )
      // 描述
      v-row.mb-8(style='margin-top: -10px')
        v-col.pa-0(cols='3').d-flex.justify-start
          div(style='color:#444444; font-weight: 500; font-size: 14px;') {{$t('ADD_KNOWLEDGE.DESCRIPTION')}}
        v-col.pa-0
          v-textarea.pa-0.textarea-style(
            v-model="addData.description",
            outlined,
            :placeholder=`$t('ADD_KNOWLEDGE.DESCRIPTION_PH')`,
            :rules='formRule.descriptionRules',
            required='required',
            height='100',
            no-resize
            :hint=`$t('ADD_KNOWLEDGE.DESCRIPTION_HINT')`
            persistent-hint         
          ) 
    div.d-flex.align-center.justify-end(style='background-color: #f4f4f4; width: 480px; height:60px; margin-left:-24px; margin-bottom: -20px;')
      v-btn.mr-4(
        :ripple="false",
        @click="onCancel",
        width="100",
        height="40",
        color="cancel",
        depressed,
        outlined,
        style='font-weight: 700;'
      ) {{$t('GENERAL.CANCEL')}}
      v-btn.mr-6(
        :ripple="false",
        @click="onConfirm",
        width="100",
        height="40",
        color="#14C6DE",
        depressed,
        dark,
      ) 
        v-progress-circular(v-if='addBtn_loading' indeterminate size='20')
        .t-white(v-else style='font-weight: 700;') {{$t('GENERAL.ADD')}}

  v-dialog(v-model='messageDialog' width='360' content-class='statusDialog' v-if='messageDialog')
      message-dialog(@emitMessageDialog='onEmitMessageDialog' :message='message' )
  v-dialog(v-model='errorDialog' width='360' content-class='statusDialog' @keydown.esc='onEmitErrorDialog(false)' @keydown.enter='onEmitErrorDialog(true)')
      error-dialog(@emitErrorDialog='onEmitErrorDialog' :errorMessage='errorMessage')
  v-dialog(v-model='folderPickerDialog' width='680' @keydown.esc="onCancel" content-class='statusDialog' v-if='folderPickerDialog')
    folder-location-picker-dialog(:selected-id='addFolderData.parent_id' @confirm='onFolderPickerConfirm' @cancel='onFolderPickerCancel' v-model='folderPickerDialog')
</template>

<script>
import Vue from "vue";
import messageDialog from '@/components/Dialog/redirectDialog';
import errorDialog from "@/components/Dialog/errorDialog";
import i18n from '/common/plugins/vue-i18n.js';
import KnowledgeLibraryService from "@/services/KnowledgeLibraryService";
import folderLocationPickerDialog from "@/components/GPT_Dialog/Knowledge/folderLocationPickerDialog";


export default Vue.extend({
  props: {
    is_private: {
        type: Boolean,
        default: false
    },
    parentPath:{
      type: String,
      default: "/",
    },
    parentFolder: {
      type: String,
      default: null,
    },
  },
  components: {            
      messageDialog,
      errorDialog,
      folderLocationPickerDialog
  },
  data() {
    return {
      addBtn_loading:false,
      addData : {},
      messageDialog:false,
      message:"",
      errorDialog: false,
      errorMessage: "",
      valid: true,
      category_list: [],
      formRule: {
        nameRules: [
          (v) => !!v || i18n.t('RULE.RULE_R'),
          (v) => /^.{0,100}$/.test(v) || i18n.t('RULE.RULE_100'),
          (v) => /^[\u4e00-\u9fa5_a-zA-Z0-9\s]+$/.test(v) || i18n.t('RULE.NO_SPECIAL_SYMBOL')
        ],
        pathRules: [
                (v) => !!v || i18n.t('RULE.RULE_R'),
                (v) => /^.{0,200}$/.test(v) || i18n.t('RULE.RULE_200'),
        ],
        system_nameRules: [
          (v) => !!v || i18n.t('RULE.RULE_R') , // 必填
          (v) => /^[a-zA-Z0-9_]+$/.test(v) || i18n.t('RULE.RULE_ALPHA_NUMERIC'), // 只能輸入英文字母和數字或底線
          (v) => (v.length <= 30) || i18n.t('RULE.RULE_30')  // 最多 30 個字
        ],
        descriptionRules: [
          (v) => !!v || i18n.t('RULE.RULE_R'),
          (v) => /^.{0,100}$/s.test(v) || i18n.t('RULE.RULE_100')
        ],
        categoryRules: [
          (v) => !!v || i18n.t('RULE.RULE_R'),
          (v) => /^.{0,30}$/.test(v) || i18n.t('RULE.RULE_30')
        ],
      },
      //folder
      addFolderData: {
        name: "",
        path: this.parentPath,
        parent_id: this.parentFolder,
      },
      folderPickerDialog: false,
      folder_mode: false,
    };
  },
  async created(){
    this.get_upgpt_setting();
    this.addData.name = '';
    this.addData.description = '';
    this.addData.id = 0
    this.addData.system_name = '';
    this.addData.category = '';
    await KnowledgeLibraryService.getknowledgecategoryoption().then((response)=>{
      this.category_list = response.data;
    })
  },
  methods: {
    async get_upgpt_setting(){
      let setting = await this.upgpt_image_func_setting();
      this.folder_mode = setting['knowledge_folder'];
    },
    validateForm() {
      if (this.$refs.form.validate()) 
        return true;
      else 
        return false;
    },
    async onConfirm() {
      if (this.validateForm() && !this.addBtn_loading) {
        this.addBtn_loading = true;
        if (typeof this.addData.category === 'object' && this.addData.category !== null) {
          this.addData.category =  this.addData.category.name;
        }
        if(!this.is_private && this.addFolderData.parent_id){
          if(this.addFolderData.parent_id== "Root"){
            this.addFolderData.parent_id=null;
          }
          this.addData.parent_folder = this.addFolderData.parent_id;
        }
        KnowledgeLibraryService.create(this.addData,this.is_private).then((response)=>{
          if(response.data == "same name block"){
            this.showErrorDialog(i18n.t('GPT_KNOWLEDGE.ERROR'));
            this.addBtn_loading = false;
          }
          else if(response.data == "same system name block"){
            this.showErrorDialog(i18n.t('GPT_KNOWLEDGE.SYSTEM_NAME_ERROR'));
            this.addBtn_loading = false;
          }
          else{
            this.$emit("emitAddDialog", true ,response.data);
          }
        }).catch(response => {
          if (response.response.status == 403)
          {
              this.$emit("emitAddDialog", true ,"no_auth");
          }
        });        
      }
    },
    onCancel() {     
      this.$emit("emitAddDialog", false);
    },
    showMessageDialog(msg) {                
        this.messageDialog = true;
        this.message = msg;
    },
    async onEmitMessageDialog(val) {
      if(val){
        // 
      }
    },
    showErrorDialog(message) {
      this.errorDialog = true;
      this.errorMessage = message;
    },
    onEmitErrorDialog() {
      this.errorDialog = false;
    },
    openFolderPick(){
      this.folderPickerDialog = true;
    },
    onFolderPickerCancel() {
      this.folderPickerDialog = false;
    },
    onFolderPickerConfirm({ id, parent_folder, path }) {
      this.addFolderData.parent_id = id;   // 回填選到的位置 id
      this.addFolderData.parent_folder = parent_folder;
      this.addFolderData.path = path;
      this.folderPickerDialog = false;
    },
  },
});
</script>